import { Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import { ConfirmModal } from "~/shared/components/ConfirmModal"

type EnrollmentCancellatioConfirmModalProps = {
  onConfirm: () => Promise<unknown>
  onClose: () => void
  isVisible: boolean
}

export function EnrollmentCancellationConfirmModal({
  onConfirm,
  onClose,
  isVisible,
}: EnrollmentCancellatioConfirmModalProps) {
  const [t] = useTranslation("benefits/EnrollmentCancellationConfirmModal")
  return (
    <ConfirmModal
      data-testid="enrollment-cancellation-confirm-modal"
      visible={isVisible}
      title={t("title")}
      onOk={onConfirm}
      onClose={onClose}
    >
      <Text>
        <Trans
          t={t}
          defaults={t("disclaimer")}
          components={{
            b: <Text as="span" className="font-semibold text-error-darken-100" />,
            br: <br />,
          }}
        />
      </Text>
    </ConfirmModal>
  )
}
